import type Lenis from 'lenis';

let lenisInstance: Lenis | null = null;

/** Registra la instancia activa de Lenis (la crea Layout). */
export const registerLenis = (instance: Lenis | null) => {
  lenisInstance = instance;
};

/**
 * Desplaza suavemente a una sección por selector (ej. '#cta-final').
 * Importante: el `scrollIntoView({ behavior: 'smooth' })` nativo es cancelado
 * por Lenis, así que usamos su `scrollTo`. Si Lenis no está activo, cae al nativo.
 */
export const scrollToSection = (target: string) => {
  if (lenisInstance) {
    lenisInstance.scrollTo(target, { offset: 0 });
    return;
  }
  document.querySelector(target)?.scrollIntoView({ behavior: 'smooth' });
};
